// Redux Slice for AI Service
import axiosInstance from "./axios.instance";

// Async actions for AI Slice
export const API_REGISTER_COMPANY = async (formData) => {
  try {
    const response = await axiosInstance.post("/ai/register", formData);
    return response.data;
  } catch (error) {
    console.log("Error in API_REGISTER_COMPANY:", error);
    throw error;
  }
};


export const API_CHECK_COMPANY_REGISTRATION = async () => {
  try {
    const response = await axiosInstance.get("/ai/company");
    return response.data;
  } catch (error) {
    console.log("Error in API_CHECK_COMPANY_REGISTRATION:", error);
    throw error;
  }
};
export const API_UPDATE_COMPANY = async (updates) => {
  try {
    const response = await axiosInstance.put("/ai/company", updates);
    return response.data;
  } catch (error) {
    console.log("Error in API_UPDATE_COMPANY:", error);
    throw error;
  }
};
export const API_STOP_AI_SERVICE = async () => {
  try {
    const response = await axiosInstance.delete("/ai/stop");
    return response.data;
  } catch (error) {
    console.log("Error in API_STOP_AI_SERVICE:", error);
    throw error;
  }
};

export const API_START_AI_SERVICE = async (form) => {
  try {
    const response = await axiosInstance.post("/ai/start", form);
    return response.data;
  } catch (error) {
    console.log("Error in API_START_AI_SERVICE:", error);
    throw error;
  }
};
export const API_UPDATE_FAQ = async (updates) => {
  try {
    const response = await axiosInstance.post("/ai/company/faqs", updates);
    return response.data;
  } catch (error) {
    console.log("Error in API_UPDATE_FAQ:", error);
    throw error;
  }
};
export const API_GET_AI_FAQ = async () => {
  try {
    const response = await axiosInstance.get("/ai/company/faqs");
    return response.data;
  } catch (error) {
    console.log("Error in API_GET_AI_FAQ:", error);
    throw error;
  }
};
export const API_DELETE_FAQ = async (data) => {
  try {
    const response = await axiosInstance.delete("/ai/company/faqs", {
      data: data,
    });
    return response.data;
  } catch (error) {
    console.log("Error in API_DELETE_FAQ:", error);
    throw error;
  }
};
